module.exports = __webpack_public_path__ + "5f4bacd72c5f3a742cbe347adf061f09.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/termine/Diskofieber2.jpg
// module id = 700
// module chunks = 0